import { Uppdrag } from "types/uppdrag.type";

import { HasSentStatus } from "types/transportDocument.type";
import { cn } from "helpers/classNames";
import { Customer } from "./Customer";
import { WasteStation } from "./WasteStation";
import { ParentCustomer } from "./ParentCustomer";

type Props = {
  uppdrag: Uppdrag;
};
export const Bilagor = ({ uppdrag }: Props) => {
  const showWasteStationSection =
    uppdrag.emailToWasteStationStatus !== HasSentStatus.NotApplicable;
  return (
    <div
      className={cn(
        "mb-4 grid grid-cols-1 gap-4",
        showWasteStationSection && "lg:grid-cols-2",
      )}
    >
      {uppdrag.parentCustomer ? (
        <ParentCustomer uppdrag={uppdrag} />
      ) : (
        <Customer uppdrag={uppdrag} />
      )}
      {showWasteStationSection && <WasteStation uppdrag={uppdrag} />}
    </div>
  );
};
